import type { UserReviewsProps } from '@ecomm/shared-components/lib/UserReviews'

export const userReviewsData: UserReviewsProps = {
  reviews: [
    {
      name: 'Timothy',
      text: '“SimpliSafe® Outdoor Protection truly makes me feel safer. Now, I can rest easier knowing someone is checking on my cameras when I’m sleeping.”'
    },
    {
      name: 'Laura E.',
      text: '“Y’all, I just switched from a security company I will not name. I am extremely pleased.”'
    },
    {
      name: 'Crystal M.',
      text: '“Easiest. Thing. I. Have. Ever. Installed.”'
    },
    {
      name: 'Richard M.',
      text: '“This system just works. Zero complaints.”'
    }
  ]
}
